module.exports = "<span class=\"badge-product badge--circle badge--saving\" ng-class=\"::ctrl.classes\">\r\n    <span class=\"badge_title\">\r\n        save\r\n        <span class=\"badge_subtitle\">\r\n            <sup>$</sup>{{ctrl.savingsAmount | bwsDollars}}<sup ng-if=\"(ctrl.savingsAmount | bwsCents) !== '00'\">{{ctrl.savingsAmount | bwsCents}}</sup>\r\n        </span>\r\n \r\n    </span>\r\n</span>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/badges/savings-badge-template.html
 ** module id = 890
 ** module chunks = 1
 **/